import { PDFDict, PDFDocument, PDFName,PDFStream } from "pdf-lib";
import { XMLParser } from "fast-xml-parser";
import pako from 'pako'

export function extractFacturXFields(json) {
  const invoice = json['rsm:CrossIndustryInvoice'];

  const emitter = invoice?.['rsm:SupplyChainTradeTransaction']
    ?.['ram:ApplicableHeaderTradeAgreement']?.['ram:SellerTradeParty'];
  const recipient = invoice?.['rsm:SupplyChainTradeTransaction']
    ?.['ram:ApplicableHeaderTradeAgreement']?.['ram:BuyerTradeParty'];
  const monetary = invoice?.['rsm:SupplyChainTradeTransaction']
    ?.['ram:ApplicableHeaderTradeSettlement']?.['ram:SpecifiedTradeSettlementHeaderMonetarySummation'];
  const number = invoice?.['rsm:ExchangedDocument']?.['ram:ID']
  console.log(number)
  const issueDate = invoice?.['rsm:ExchangedDocument']?.['ram:IssueDateTime']?.['udt:DateTimeString']?.['#text'];
  const emitterName = emitter?.['ram:Name'];
  const recipientName = recipient?.['ram:Name'];
  const totalTTC = monetary?.['ram:GrandTotalAmount'];

  return {
    emitter: emitterName || 'N/A',
    recipient: recipientName || 'N/A',
    totalTTC: totalTTC || 'N/A',
    number:number,
    date: issueDate || 'N/A',
  };
}


export async function XmlExtractor(xmlFile){
  console.log('MESS',xmlFile)
  const arrayBuffer=await xmlFile.arrayBuffer()
  console.log("FILE",arrayBuffer)
  const pdfDoc = await PDFDocument.load(arrayBuffer)
  console.log("DOCNAMES",pdfDoc.catalog.has(PDFName.of('AF'),PDFDict))

  console.log("D2",pdfDoc.catalog.has(PDFName.of('EF'),PDFDict))
  const AFArray = pdfDoc.catalog.lookup(PDFName.of(('AF'),PDFDict))
  console.log(AFArray)
  for (const fileSpecRef of AFArray.array){
    console.log("F",fileSpecRef) 
    var fileSpec
    try {
     fileSpec = pdfDoc.context.lookup(fileSpecRef);
    }
    catch(e){
      console.log("E",e)
    }
     const fileName = fileSpec.get(PDFName.of('UF'))?.decodeText?.() ||
      fileSpec.get(PDFName.of('F'))?.decodeText?.() ||
      'unknown.xml';

      console.log(fileName)
  }
  const embeddedFiles=pdfDoc.catalog.lookupMaybe('Names','EmbeddedFiles')
  
  console.log("READFACT")
  if(!embeddedFiles){
    alert('Facture non reconnue')
  }

  else {
    console.log('EMB',embeddedFiles)
  }
}

export async function extractFacturX(pdfFile) {
  // Lire le PDF
  const arrayBuffer = await pdfFile.arrayBuffer();
  const pdfDoc = await PDFDocument.load(arrayBuffer);

  // Accéder au champ /AF dans le catalogue
  const afArrayRaw = pdfDoc.catalog.lookup(PDFName.of('AF'));
  if (!afArrayRaw || !Array.isArray(afArrayRaw.array)) {
    throw new Error('❌ Aucun fichier XML intégré trouvé dans /AF.');
  }

  // Prendre la première entrée (généralement le XML Factur-X)
  const fileSpecRef = afArrayRaw.array[0];
  const fileSpec = pdfDoc.context.lookup(fileSpecRef, PDFDict); // lookup() sur le context

  // Lire les infos de fichier
  const filename =
    fileSpec.get(PDFName.of('UF'))?.decodeText?.() ||
    fileSpec.get(PDFName.of('F'))?.decodeText?.() ||
    'unknown.xml';
  
  const efDict = fileSpec.lookup(PDFName.of('EF'), PDFDict);
  console.log("F",efDict)
  const fileStream = efDict.lookup(PDFName.of('F'), PDFStream);
    console.log("F",fileStream)
  const fileBytes =  fileStream.asUint8Array();
     console.log("F",fileBytes)
   var uncompressed  
   try{
    uncompressed = pako.inflate(fileBytes)
   }
   catch(e){
    console.log("inflate",e)
   }
   console.log(uncompressed)
  const xmlString = new TextDecoder('utf-8').decode(uncompressed);
      console.log("X",xmlString)
  // Vérification contenu Factur-X
  if (
    !xmlString.includes('urn:factur-x.eu') &&
    !xmlString.includes('CrossIndustryInvoice')
  ) {
    throw new Error(`❌ Le fichier intégré "${filename}" n'est pas une facture Factur-X.`);
  }
  console.log("PAS BOUM ")
  // Parsing XML → JSON
  const parser = new XMLParser({ ignoreAttributes: false });
  const json = parser.parse(xmlString);
  console.log(json)
  return {json:json,xml:xmlString};
}

export async function extractFacturX2(xmlFile) {

    const arrayBuffer = await xmlFile.arrayBuffer();
    console.log("BUF",arrayBuffer)
    const pdfDoc = await PDFDocument.load(arrayBuffer)
    console.log(pdfDoc)
    const AFArray = pdfDoc.catalog.lookup(PDFName.of(('AF'),PDFDict))
  console.log(AFArray)
    const attachement= AFArray
   console.log(attachement)
    if (!attachement){
      console.log("AUCUN")
        throw new Error ('Aucun fichier')
    }
 
   // const embeddedFiles = attachement.context.lookup(attachement.get(PDFName.of('Names')))
    const xmlEmbedded = pdfDoc.context.lookup(attachement.array[0]);
    console.log("XML",xmlEmbedded)
    const xmlData = xmlEmbedded.get(PDFName.of('EF')).lookup(PDFName.of('F')).getBytes();
     console.log("XMLData",xmlData)
  const xmlString = new TextDecoder().decode(xmlData);

  const parser = new XMLParser();
  const json = parser.parse(xmlString);
  console.log(json)
  return json;
}
